<section class="aarni-font w-full shadow border-b  py-[50px] mt-[80px]">
    <div class="container mx-auto px-4">
        <h1 class=" text-center md:text-start font-bold text-[32px]">
            {{ pageTitle }}
        </h1>
    </div>
</section>

<section class="aarni-font">
    <div class="container mx-auto flex flex-col lg:flex-row gap-8 py-12 px-4">
        <aside class="w-full lg:w-1/4 space-y-4 md:max-h-screen md:overflow-y-auto overflow-x-hidden pr-2">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Leadership</h2>
                    <div class="">
                        <a [href]="'/about/leadership/chancellor'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Chancellor', 'text-blue-600 bg-white' : pageTitle !== 'Chancellor'}"
                           class="flex items-center space-x-2 p-3 w-full border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Chancellor</span>
                        </a>
                        <a [href]="'/about/leadership/osd'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Director Operations', 'text-blue-600 bg-white' : pageTitle !== 'Director Operations'}"
                           class="flex items-center space-x-2 p-3 w-full border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Director Operations</span>
                        </a>
                        <a [href]="'/about/leadership/vice-chancellor'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Vice Chancellor', 'text-blue-600 bg-white' : pageTitle !== 'Vice Chancellor'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Vice Chancellor</span>
                        </a>
                        <a [href]="'/about/leadership/pro-vice-chancellor'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Pro Vice Chancellor', 'text-blue-600 bg-white' : pageTitle !== 'Pro Vice Chancellor'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Pro Vice Chancellor</span>
                        </a>
                        <a [href]="'/about/leadership/dean-academic-affairs'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Dean Academic Affairs', 'text-blue-600 bg-white' : pageTitle !== 'Dean Academic Affairs'}"
                           class="flex items-center space-x-2 p-3 w-full  border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Dean Academic Affairs</span>
                        </a>
                        <a [href]="'/about/leadership/registrar'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Registrar', 'text-blue-600 bg-white' : pageTitle !== 'Registrar'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Registrar</span>
                        </a>
                        <!-- <a [href]="'/about/leadership/dean-r-and-d'"
                            [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Dean R & D', 'text-blue-600 bg-white' : pageTitle !== 'Dean R & D'}"
                            class="flex items-center space-x-2 p-3 w-full  border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                         >
                             <i class="fa fa-arrow-right"></i>
                             <span>Dean R & D</span>
                         </a>-->
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4 hidden lg:block">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow  hidden lg:block border-gray-200 border-2 ">
                <div class="space-y-2">
                    <a href="/about/faculty" class="flex items-center  space-x-3 p-2 rounded-lg">
                        <div>
                              <span
                                  class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium   md:text-[16px] xl:text-xl ">Faculty</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2 ">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                             <span
                                 class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium  md:text-[16px] xl:text-xl ">Testimonials</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
                             <span
                                 class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span>
                        </div>

                        <span class="text-gray-700 font-medium  md:text-[16px] xl:text-xl ">Contact Us</span>
                    </a>
                </div>
            </div>
        </aside>
        <div class="flex-1">
            <div class="md:p-12 shadow-lg border-gray-200 bg-white h-fit ">
                <h3 class="font-semibold text-[22px]">
                    {{ pageTitle }}
                </h3>
                <div *ngIf="pageTitle === 'Chancellor'" class=" px-0">
                    <div class=" ">
                        <div class="bg-[url(assets/img/top-leadership/chancellor-arni.jpg)] h-[450px] bg-top bg-cover">
                        </div>
                        <div class="bg-yellow-500 text-white p-6">
                            <p class="font-bold text-2xl ">Dr. Vivek Singh</p>
                            <p class="text-lg font-semibold">Hon'ble Chancellor, Arni University</p>
                        </div>
                        <div class="relative px-6 py-6 my-2">
                            <i class="fa fa-quote-left absolute left-[-0%] text-gray-700 text-4xl top-0"></i>
                            <p class="text-gray-500 text-justify my-3">
                                Higher education institutions have long been crucial to a country's social and economic
                                advancement. Arni University's position as a hub for learning, teaching, research, and
                                excellence has grown increasingly important as the amount of human knowledge grows at an
                                accelerated rate. ARNI views education holistically and equips students with the
                                information and abilities they need to fully contribute to the nation's economic growth.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                It is with immense pride and privilege that I announce a transformative chapter in the
                                journey of Arni University under the guidance of our new management. Our unwavering
                                commitment is to propel Arni University to unprecedented heights, positioning it as a
                                premier “Five-Star” educational institution in the country. Everything possible,
                                including infrastructure, upgrading of equipment, latest books, and administrative /
                                welfare facilities would be catered for to excel in the field of education. As the new,
                                yet experienced Management, we have been investing our earnest efforts to take our
                                University to become one of the best universities in the advancement of academic, human
                                capital index, research & innovation. Guided by this vision, the University has
                                strategically positioned itself to train our students to meet the development needs of
                                the country and the international human resources market.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                We also feel that it is not only the knowledge or degrees alone that produce good
                                citizens, but also the culture, ethos, values, and conducive environment which adds to
                                the leadership skills and personality as much as the knowledge. Accordingly, we have
                                designed and nurtured the learning and teaching process by hiring or partnering with,
                                the best talents/experts available in the country.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                It is my proud privilege to formally welcome all fresh students to Arni University and I
                                hope that they all will be immensely by joining us. I would like to assure everyone that
                                we are fully dedicated to providing quality accredited career-focused education to our
                                students. To achieve this, an immersive curriculum in our University, supported by
                                industry, has been developed to prepare our students pragmatically to create a 'Centre
                                of Excellence'. I am determined and clear in my mind that we will achieve our set goals.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                We thank everyone for taking an interest in our University.
                            </p>
                            <span
                                class="bg-[#EEE9D4] leading-relaxed font-semibold text-gray-900 px-2 py-[3px] text-xl">
                      "Leadership is not about being in charge. It is about taking care of those in your charge."
                    </span>
                            <i class="fa fa-quote-right absolute right-[-0%] text-gray-700 text-4xl bottom-0"></i>
                        </div>

                    </div>
                    <div class="bg-[#EEE9D4] w-full mx-0 p-6">
                        <h2 class="font-bold text-2xl mt-4">
                            Profile
                        </h2>
                        <p class="text-gray-500 text-justify my-3">
                            Dr. Vivek Singh, the Chancellor of the ARNI University, is a leading educational reformer
                            who has transformed teaching methodology across India with his dedication and hard work. The
                            ARNI University was established by Act No.23 of 2009 of the Government of Himachal Pradesh
                            and approved by the UGC, vide Notification No- F No 8-5/2010(CPP-1/PU), dated 03 Mar 2010,
                            under Section 2 (f) of the UGC Act, 1956. Ever since he joined ARNI, Singh has aimed to
                            create an application-based education system that nurtures talent and curiosity in young
                            individuals. While serving as the chancellor, he also aimed to address the custom of not
                            providing higher education to girls, granting huge scholarships to girls whose families
                            could not afford tuition fees.
                        </p>
                        <p class="text-gray-500 text-justify my-3">
                            Having been involved in the education industry, he delved deep to understand the lackluster
                            output of the industry. This unveiled many facts, like the fact that the examination system
                            only tested the memory rather than the intelligence of the students and the fact that
                            teachers only incorporated theoretical knowledge in the classrooms and were exposed to the
                            practical knowledge prevailing outside in the market. Hence, an education system that would
                            inculcate an application-based approach in the young students envigored the thought of
                            opening up educational institutions that would focus more on nurturing the talent and
                            developing curiosity in young individuals, in his mind.
                        </p>
                        <h2 class="font-bold text-xl  mt-4 ">
                            Key Attributes That Make Him a Leader
                        </h2>
                        <ul class="list-disc px-6">
                            <li>
                                <p class="text-gray-500">
                                    ARNI University (AU) came into existence by Act No.23 of 2009 of the Government of
                                    Himachal Pradesh.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    Dr. Singh has introduced special provisions for students from defense families,
                                    including participation in the Jammu and Kashmir Scholarship Scheme, demonstrating a
                                    dedication to supporting those who serve the nation.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    Under his leadership, Arni University organized a two-day bike rally promoting
                                    anti-drug awareness and women's empowerment, reflecting his commitment to societal
                                    well-being and gender equality.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    He advocates for a comprehensive educational experience that combines academic
                                    excellence with soft skills and personality development, preparing students for both
                                    professional and personal success.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Director Operations'" class=" px-0">
                    <div class=" ">
                        <div class="bg-[url(assets/img/top-leadership/mehr-un-nisa.png)] h-[450px] bg-top bg-cover">
                        </div>
                        <div class="bg-yellow-500 text-white p-6">
                            <p class="font-bold text-2xl ">Ms. Mehr Un Nisa</p>
                            <p class="text-lg font-semibold">Director Operations & Officer on Special Duty to the
                                Hon’ble Chancellor, ARNI University</p>
                        </div>
                        <div class="relative px-6 py-6 my-2">
                            <i class="fa fa-quote-left absolute left-[-0%] text-gray-700 text-4xl top-0"></i>
                            <p class="text-gray-500 text-justify my-3">
                                At Arni University, we believe in providing quality education that prepares students for
                                both professional success and responsible citizenship. With the support and guidance of
                                our Hon’ble Chancellor, the university is growing with a clear focus on academic
                                excellence, discipline, and overall development of students.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                As Director–Operations and Officer on Special Duty to Chancellor, my
                                responsibility is to ensure that all departments work in coordination, policies are
                                followed properly, and students receive the best environment to learn and grow. We are
                                committed to maintaining a campus culture that is safe, supportive, and focused on
                                progress.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                Our goal is to offer not just education, but opportunities—for learning, innovation,
                                skill-building, and leadership. We aim to make Arni University a place where students
                                are inspired, faculty members are motivated, and every stakeholder feels proud to be
                                part of this journey.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                We welcome students, parents, faculty, and well-wishers to be a part of our mission to
                                build a better future through education.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                Warm regards,
                            </p>
                            <p class="text-gray-500 text-justify font-semibold">
                                Ms. Mehr Un Nisa
                            </p>
                            <p class="text-gray-500 text-justify font-semibold">
                                OSD to Chancellor & Director–Operations
                            </p>
                            <p class="text-gray-500 text-justify font-semibold">
                                ARNI University
                            </p>
                            <i class="fa fa-quote-right absolute right-[-0%] text-gray-700 text-4xl bottom-0"></i>
                        </div>
                    </div>
                </div>
                <!--<div *ngIf="pageTitle === 'Dean R & D'" class="px-0 ">
                    <div class="">
                        <div
                            class="bg-[url(assets/img/top-leadership/dr-ashish-kumar-sharma-dean-r-and-d.webp)] h-[450px] bg-top bg-cover">
                        </div>
                        <div class="bg-yellow-500 text-white p-6">
                            <p class="font-bold text-2xl ">Dr. Ashish Kumar Sharma</p>
                            <p class="text-lg font-semibold">Incharge and Deputy Dean R&D, ARNI University</p>
                        </div>
                        <div class="relative px-6 py-6 my-2">
                            <i class="fa fa-quote-left absolute left-[-0%] text-gray-700 text-4xl top-0"></i>
                            <p class="text-gray-500 text-justify my-3">
                                I am pleased to welcome all students, professors, researchers, and partners who share
                                our dedication to promoting knowledge and encouraging innovation. As Dean of Research
                                and Development, I am honored to share our commitment to pushing the boundaries of
                                discovery and contributing to societal improvement.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                Research is at the heart of our academic institution, propelling us forward and
                                influencing the future. Our faculty members are at the vanguard of their areas,
                                undertaking breakthrough research that addresses complicated issues and offers up new
                                avenues of exploration. We take pleasure in fostering an environment of intellectual
                                curiosity, cooperation, and excellence.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                Our mission is to empower faculty and students to pursue cutting-edge research that
                                addresses contemporary challenges and contributes to the global body of knowledge. We
                                strive to create an environment where curiosity is nurtured, critical thinking is
                                encouraged, and scholarly pursuits are supported.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                Through strategic partnerships, advanced facilities, and a focus on quality work, we aim
                                to position ARNI University as a hub for research excellence. Our partnerships with
                                industry, government agencies, and other academic institutions further amplify the
                                impact of our research. Together, we strive to create solutions that address real-world
                                challenges, foster innovation, and contribute to the advancement of society.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                I invite all members of our academic community to engage actively in research
                                initiatives and contribute to our shared vision of innovation and progress.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                Together, we can make significant strides in research and development, shaping a better
                                future for society.
                            </p>
                            <p class="text-gray-500 text-justify mt-3">
                                Dean R&D
                            </p>
                            <p class="text-gray-500 text-justify">
                                Dr. Ashish Kumar Sharma
                            </p>
                            <i class="fa fa-quote-right absolute right-[-0%] text-gray-700 text-4xl bottom-0"></i>
                        </div>
                    </div>
                    <div class="bg-[#EEE9D4] w-full mx-0 p-6">
                        <h2 class="font-bold text-2xl mt-4">
                            Profile
                        </h2>
                        <p class="text-gray-500 text-justify my-3">
                            Dr. Ashish Kumar Sharma serves as the Head of the Department of Mathematics at ARNI
                            University, Kathgarh, Himachal Pradesh. With a robust academic background and a passion for
                            interdisciplinary research, Dr. Sharma has been instrumental in integrating mathematical
                            principles with practical applications across various fields. His leadership in organizing
                            international conferences and commitment to academic excellence have significantly
                            contributed to the university's reputation as a center for innovative learning and research.
                        </p>
                        <h2 class="font-bold text-xl  mt-4 ">
                            Key Attributes That Make Him a Leader
                        </h2>
                        <ul class="list-disc px-6">
                            <li>
                                <p class="text-gray-500">
                                    Dr. Ashish Kumar Sharma is the Head of the Department of Mathematics, fostering a
                                    culture of analytical thinking and practical application, emphasizing rigorous
                                    academic standards and curriculum development.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    Organized international conferences, facilitating knowledge exchange and networking
                                    among scholars. Encourages interdisciplinary research projects, bridging gaps
                                    between various fields of study.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    Committed to mentoring students and young researchers, nurturing the next generation
                                    of academicians. Actively engages in research initiatives, encouraging student
                                    participation in projects that address real-world problems.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    Advocates for a curriculum that balances theoretical knowledge with hands-on
                                    experience, preparing students for diverse career paths. Collaborates with
                                    international institutions to bring diverse perspectives and expertise to the
                                    university community.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>-->
                <div *ngIf="pageTitle === 'Vice Chancellor'">
                    <div class="">
                        <div
                            class="bg-[url(assets/img/top-leadership/vice-chancellor-arni.jpg)] h-[450px] bg-top bg-cover">
                        </div>
                        <div class="bg-yellow-500 text-white p-6">
                            <p class="font-bold text-2xl ">Prof.(Dr.) R.K. Pandey</p>
                            <p class="text-lg font-semibold">Hon'ble Vice Chancellor, Arni University</p>
                        </div>
                        <div class="relative px-6 py-6 my-2">
                            <i class="fa fa-quote-left absolute left-[-0%] text-gray-700 text-4xl top-0"></i>
                            <p class="text-gray-500 text-justify my-3">
                                I am honored and privileged to serve as Vice Chancellor at Arni University, Kangra
                                District, Himachal Pradesh. The university stands on the Principles of making Education
                                the pathway to make students confident by imparting appropriate skills and knowledge
                                that are the need of the industry and Society at large. It is envisaged that the
                                University nurture talent who can contribute responsibly to the future Society. We at
                                Arni University focus on imparting knowledge, skills to make students a person of value
                                with high morals and ethics.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                We believe and follow the philosophy of Swami Vivekananda: “We want the education by
                                which character is formed, strength of mind is increased, the intellect is expanded, and
                                by which one can stand on one’s own feet”. Arni University strive to create empowered
                                youth in multiple domains of Sciences, Technologies, Life Sciences,
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                Management, Literature, Agriculture, Health Sciences, Education, Law, Pharmacy,
                                Biolechnology and many more, who are provided hands on skilling, foundation skilling,
                                up-skilling, reskilling and building future skills acumen at all levels with multiple
                                entry and exit options.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                Our students are provided the opportunity to develop entrepreneurial, scientific, and
                                societal mindsets; they shall become collaborative and have a global outlook through
                                pedagogical frameworks developed in classrooms, laboratories, and fieldwork. We at Arni
                                University focus on providing open-minded research and an experimental atmosphere so
                                that a complete personality comes out in the students. Our Focus remains on being a
                                University that shall scale up employability by way of developing job seekers and job
                                givers.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                JAI HIND!
                            </p>
                            <i class="fa fa-quote-right absolute right-[-0%] text-gray-700 text-4xl bottom-0"></i>
                        </div>

                    </div>
                    <div class="bg-[#EEE9D4] w-full mx-0 p-6">
                        <h2 class="font-bold text-2xl  mt-4 ">
                            Profile
                        </h2>
                        <p class="text-gray-500 text-justify my-3">
                            Prof. (Dr.) R.K. Pandey is a distinguished academic leader with extensive experience in
                            engineering education. He serves as the Vice Chancellor of Arni University in Himachal
                            Pradesh. The leadership role at Arni University underscores his commitment to advancing
                            higher education and fostering academic excellence.
                        </p>
                        <h2 class="font-bold text-xl  mt-4 ">
                            Key Attributes That Make Him a Leader
                        </h2>
                        <ul class="list-disc px-6">
                            <li>
                                <p class="text-gray-500">
                                    As Vice Chancellor of Arni University, Dr. Pandey emphasizes equipping students with
                                    skills and knowledge aligned with industry and societal needs.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    The focus on nurturing talent to contribute responsibly to society, instilling
                                    knowledge, skills, and ethical values in students. ​
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    Dr. Pandey holds a Ph.D. in Computer Science Engineering, reflecting his expertise
                                    in the field.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Pro Vice Chancellor'">
                    <div class="">
                        <div
                            class="bg-[url(assets/img/top-leadership/pro-vice-chancellor-arni.jpg)] h-[450px] bg-top bg-cover">
                        </div>
                        <div class="bg-yellow-500 text-white p-6">
                            <p class="font-bold text-2xl ">Prof. (Dr.) Manish Kumar Srivastava</p>
                            <p class="text-lg font-semibold">Hon'ble Pro Vice Chancellor, Arni University</p>
                        </div>
                        <div class="relative px-6 py-6 my-2">
                            <i class="fa fa-quote-left absolute left-[-0%] text-gray-700 text-4xl top-0"></i>
                            <p class="text-gray-500 text-justify my-3">
                                It’s a great pleasure for me to be a part of Arni University, and I take this
                                opportunity to welcome students coming from all parts of the country and abroad, joining
                                various academic programs of Arni University.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                Education is an ongoing purposeful social process in society, through which our inherent
                                powers are developed, our knowledge and skills are increased, and our behavior is
                                changed and accordingly, we made cultured, civilized, and capable citizens. The Arni
                                University is working to transform young talent through cutting-edge education in
                                science, medicine, technology, Agriculture, education, arts, management, and many more,
                                integrated with values for their holistic development to serve mankind with empathy and
                                love.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                We are committed to providing the best learning platform for the students to participate
                                in seminars, business plan competitions, branding exercises, career advancement
                                workshops, sports, cultural activities, village development activities, social works,
                                etc. and enable students to learn and use their learning for solving issues in various
                                areas specific.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                The National Cadet Corps (NCC) wing of the University, together with the cultural
                                committee, organizes programs and activities that connect a sense of harmony, community
                                connection, ethical values, and citizenship among the students. All activities of the
                                University are aimed towards facilitating and empowering future generations by
                                supporting collaborative initiatives, promoting multidisciplinary research, and
                                strengthening their technical competence. The university also offers various
                                international Training programs and Tours as a reward for Academic Excellence with our
                                International tie-ups to give international exposure to our students. For the holistic
                                development of our students, we have prepared skill and job- oriented job-oriented
                                curricula with the help of Industry, academia, and social and cultural reformers.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                We are continuously working towards carving a position in higher education by offering
                                multidisciplinary learning opportunities and inculcating the students with core
                                competencies of the 21st century.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                I wish you great success in all your future endeavors, and assure you that we will help
                                you to pursue your objectives and help to create a path to get success in your goals.
                            </p>
                            <i class="fa fa-quote-right absolute right-[-0%] text-gray-700 text-4xl bottom-0"></i>
                        </div>

                    </div>
                    <div class="bg-[#EEE9D4] w-full mx-0 p-6">
                        <h2 class="font-bold text-2xl  mt-4 ">
                            Profile
                        </h2>
                        <p class="text-gray-500 text-justify my-3">
                            Prof. (Dr.) Manish Kumar Srivastava has a background in education from Lucknow. He had done
                            his graduation and postgraduation from Varanasi and another postgraduation from NMIMS,
                            Mumbai. He has also completed a Ph.D. He began his professional career teaching physics in
                            Varanasi, worked as an academician, and integrated industry into academia. He has pursued
                            continuous learning and is currently at Arni University, focusing on academic excellence and
                            values. Dr. Manish appreciates persistence, curiosity, and adaptability and is excited to
                            help Arni University grow.
                        </p>
                        <h2 class="font-bold text-xl  mt-4 ">
                            Key Attributes That Make Him a Leader
                        </h2>
                        <ul class="list-disc px-6">
                            <li>
                                <p class="text-gray-500">
                                    He is in charge of establishing the university's long-term academic vision, creating
                                    plans for faculty growth, student success, and the promotion of creative teaching
                                    techniques.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    Collaborate closely with faculty members to make sure they have the assistance they
                                    need for their roles in professional development, teaching, and research in order to
                                    attract and retain top-notch teachers.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    Create chances for research collaboration, internships, and academic alliances by
                                    interacting with a range of stakeholders, including government agencies, business
                                    executives, and other educational establishments.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    Participate in the senior leadership team's decision-making process regarding
                                    university governance and policies, especially those about academic matters.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Registrar'">
                    <div class="px-6">
                        <div class="bg-[url(assets/img/top-leadership/registrar-arni.jpg)] h-[450px] bg-top bg-cover">
                        </div>
                        <div class="bg-yellow-500 text-white p-6">
                            <p class="font-bold text-2xl ">Dr.Trilochan Singh</p>
                            <p class="text-lg font-semibold">Registrar, Arni University</p>
                        </div>
                        <div class="relative px-6 py-6 my-2">
                            <i class="fa fa-quote-left absolute left-[-0%] text-gray-700 text-4xl top-0"></i>
                            <p class="text-gray-500 text-justify my-3">
                                From the Desk of Registrar Arni University is one of the top-rated private universities
                                in Himachal Pradesh delivering quality education in fields such as Engineering,
                                Management, Computer Application, Sciences, Pharmacy and Agriculture. Our Arni
                                University family always advocates for innovation and excellence in the areas of
                                education, research and consultancy. Arni University is expanding under Honorable
                                Chancellor’s supervision and has done several academic collaborations with world class
                                institutions. Under these programs students get an exposure to work in various sectors
                                and in multinational set-up. Arni University has always aspired for hiring such young
                                talents who can be part of our endeavors toward the development of the nation.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                As the custodian of academic records and the steward of university policies and
                                procedures related to enrollment, registration and students records, our office is
                                committed to supporting your academic journey and ensuring the integrity and accuracy of
                                your academic records.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                At Arni University, we strive to uphold the highest standards of academic excellence and
                                integrity. Our commitment to transparency, fairness, and accuracy ensures that each
                                student’s academic journey is guided by clear policies and procedures.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                As you explore the opportunities that await you at Arni University, I encourage you to
                                reach out to our office with any questions or concerns you may have. We are here to help
                                you make informed decisions and embark on a fulfilling academic experience.
                            </p>
                            <i class="fa fa-quote-right absolute right-[-0%] text-gray-700 text-4xl bottom-0"></i>
                        </div>
                    </div>
                    <div class="bg-[#EEE9D4] w-full mx-0 p-6">
                        <h2 class="font-bold text-2xl mt-4">
                            Profile
                        </h2>
                        <p class="text-gray-500 text-justify my-3">
                            Dr. Trilochan Singh serves as the Registrar at Arni University, Himachal Pradesh. In this
                            capacity, he plays a pivotal role in the university's administration and academic
                            coordination. Dr. Singh's leadership and dedication significantly contribute to Arni
                            University's reputation as a leading institution committed to academic excellence and
                            holistic development.

                        </p>
                        <h2 class="font-bold text-xl  mt-4 ">
                            Key Attributes That Make Him a Leader
                        </h2>
                        <ul class="list-disc px-6">
                            <li>
                                <p class="text-gray-500">
                                    As Registrar, Dr. Singh oversees the implementation of academic policies and ensures
                                    the smooth functioning of the university's administrative operations.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    Dr. Singh advocates for innovation and excellence in education, research, and
                                    consultancy, contributing to the university's mission of delivering quality
                                    education across various disciplines.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    He actively participates in university events and initiatives, reflecting his
                                    dedication to the institution's growth and community engagement.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Dean Academic Affairs'">
                    <div class="">
                        <div
                            class="bg-[url(assets/img/top-leadership/dean-of-academic-affairs-arni.jpg)] h-[450px] bg-top bg-cover">
                        </div>
                        <div class="bg-yellow-500 text-white p-6">
                            <p class="font-bold text-2xl ">Prof. (Dr.) R.K. Kaundal</p>
                            <p class="text-lg font-semibold">Dean Academic Affairs, Arni University</p>
                        </div>
                        <div class="relative px-6 py-6 my-2">
                            <i class="fa fa-quote-left absolute left-[-0%] text-gray-700 text-4xl top-0"></i>
                            <p class="text-gray-500 text-justify my-3 font-bold">
                                "In an era defined by transformation and limitless possibilities, ARNI University stands
                                as a
                                catalyst for shaping futures with purpose, vision, and integrity."
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                As the Dean of Academic Affairs, I take great pride in inviting you to a university that
                                dares to
                                go beyond the conventional, I am privileged to oversee a vibrant academic community
                                dedicated to
                                fostering intellectual curiosity, innovation, and personal growth. At ARNI, education
                                is not
                                confined to classrooms—it is an evolving journey of curiosity, creativity, and courage.
                                Our
                                academic ecosystem is designed to ignite minds, encourage innovation, and empower
                                students to
                                turn ideas into action.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                At ARNI University, we are committed to providing a world-class education that prepares
                                you for success in an ever-evolving global landscape. We pride ourselves on our
                                student-centered approach, offering personalized academic advising, experiential
                                learning opportunities, and robust support services to ensure your success. From
                                innovative research projects to internships, and industry partnerships, we provide the
                                tools you need to turn your aspirations into reality. Our commitment to inclusivity and
                                diversity ensures that every student’s voice is valued, creating a dynamic community
                                where ideas flourish.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                As you consider your future, I invite you to explore our diverse academic offerings,
                                connect with our admissions team, and visit our campus to experience the energy and
                                opportunity that define ARNI University. We are here to support you every step of the
                                way, from your first inquiry to graduation/post graduation and beyond. We blend
                                cutting-edge knowledge with ethical values, exposure with local relevance, and theory
                                with real-world application.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                Our faculties are mentors, our classrooms are incubators of thought, and our campus is a
                                space where leadership, learning, and life converge is groomed. Here, you don’t just
                                earn a degree—you discover your purpose.
                            </p>
                            <p class="text-gray-500 text-justify my-3">
                                Welcome to ARNI University. Let your journey begin-not just to succeed, but to inspire.
                            </p>
                            <p class="text-gray-500 text-justify my-3">With best wishes,</p>
                            <p class="text-gray-500 text-justify my-3 font-bold">Prof. (Dr.) R. K. Kaundal</p>
                            <p class="text-gray-500 text-justify my-3">Dean, Academic Affairs</p>
                            <p class="text-gray-500 text-justify my-3">ARNI University</p>
                            <i class="fa fa-quote-right absolute right-[-0%] text-gray-700 text-4xl bottom-0"></i>
                        </div>

                    </div>
                    <div class="bg-[#EEE9D4] w-full mx-0 p-6">
                        <h2 class="font-bold text-2xl mt-4">
                            Profile
                        </h2>
                        <p class="text-gray-500 text-justify my-3">
                            Prof. (Dr.) R. K. Kaundal serves as the Dean of Academic Affairs at ARNI University. He
                            plays an important role in guiding the academic vision and fostering an environment of
                            intellectual growth and innovation. His leadership skills and commitment to educational
                            excellence break down the traditional educational boundaries. His guidance emphasizes a
                            holistic approach that integrates creativity, curiosity, and courage among the students.
                        </p>
                        <p class="text-gray-500 text-justify my-3">Through his vision of academic excellence, ARNI
                            University has cultivated an ecosystem that
                            not only imparts knowledge but also encourages students to transform ideas into actionable
                            outcomes. His dedication to inclusivity and diversity ensures that every student's voice is
                            valued, contributing to a dynamic community where ideas flourish.
                        </p>
                        <h2 class="font-bold text-xl  mt-4 ">
                            Key Attributes That Make Him a Leader
                        </h2>
                        <ul class="list-disc px-6">
                            <li>
                                <p class="text-gray-500">
                                    Prof. Kaundal envisions education as a transformative journey, extending beyond
                                    traditional classroom settings. He champions an academic culture that inspires
                                    students to explore, innovate, and lead with purpose.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    He believes in the continuous development of faculty members, promoting mentorship
                                    programs that enhance teaching effectiveness and academic excellence.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    Recognizing the importance of real-world applications, Prof. Kaundal advocates for
                                    experiential learning opportunities, including internships and industry
                                    partnerships, to bridge the gap between theory and practice.
                                </p>
                            </li>
                            <li>
                                <p class="text-gray-500">
                                    He fosters an inclusive academic environment where diversity is celebrated, and
                                    every student feels empowered to contribute and thrive.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>
